import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "What tools do I need to start learning Java?",
    
    description:
      "You need the JDK (Java Development Kit) along with an IDE such as IntelliJ IDEA, Eclipse, or NetBeans. These tools allow you to write, compile, test, and run Java programs efficiently.",
  },
  {
    title: "What kind of applications can I build with Java?",
   
    description:
      "With Java, you can develop Android apps, desktop software, web applications, backend systems, cloud services, games, and enterprise tools. Its versatility and reliability make Java widely used across many industries and large-scale applications.",
  },
  {
    title: "What is Java Spring Boot and why is it important?",
   
    description:
      "Spring Boot is a widely used Java framework for building backend applications. It simplifies development by managing configuration, security, and database setup, making it ideal for creating efficient APIs and enterprise-level services.",
  },
  {
    title: "Do I need to learn Java before learning Android development?",
   
    description:
      "Java was Android’s original development language, though Kotlin is now preferred. Learning Java remains valuable because many existing Android applications, libraries, and enterprise systems still rely heavily on Java-based code.",
  },
  {
    title: "What job roles are available in the Java field?",
   
    description:
      "Java offers roles such as Java Developer, Backend Developer, Full-Stack Java Developer, Spring Boot Developer, Android Developer, Microservices Engineer, Big Data Engineer, and Cloud Engineer. These positions are highly in demand across IT, finance, telecom, and enterprise sectors.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                <div className="category">{item.category}</div>

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
